import React, { useEffect, useContext } from 'react';
import ReactGA from 'react-ga';
import {
    useSetResponsibleInformationMutation,
    LoanApplicationInput,
    useSetNotificationMutation,
    useGetLoanQuery,
} from 'generated/graphql';
import { useNavigation, useNeuroId } from 'hooks/index';
import ResponsibleInfoLayout from './responsible-info-layout';
import { ProfileContext } from 'providers/profile.provider';
import { registerTagmanagerEvent, TagManagerEvent } from 'configs/trackers';
import { LoanApplicationContext } from 'containers/context/useGetLoanApplication';


const ResponsibleInfo: React.FC = () => {
    const [setResponsibleInformation] = useSetResponsibleInformationMutation();
    const [setNotification] = useSetNotificationMutation();
    const { nextScreen, previousScreen, reset } = useNavigation();
    const { loanApplicationId } = useContext(LoanApplicationContext);
    const { setUserId } = useNeuroId();
    const {
        steps: { responsibleInfo },
        profile,
    } = useContext(ProfileContext);

    const { data } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });

    useEffect(() => {
        if(!loanApplicationId) {
            reset();
        }
        setUserId(loanApplicationId);
    },[loanApplicationId])

    useEffect(() => {
        ReactGA.event({
            category: 'Navegação Direto',
            action: 'Exibição',
            label: 'Exibição /pedido/dados-pessoais',
            nonInteraction: true,
        });
    }, []);

    const onSubmit = async (loanApplication: LoanApplicationInput) => {
        const {
            responsibleName,
            email,
            responsibleDocument,
            phone,
        } = loanApplication.borrower;
        const { notifyBorrower, notifyPartner } = data?.loanApplication.notification;

        const updatedLoanApplication = {
            borrower: { responsibleName, email, responsibleDocument, phone },
            notification: { notifyBorrower, notifyPartner },
        };

        setResponsibleInformation({
            variables: {
                loanApplicationId: data?.loanApplication.id,
                borrower: { ...updatedLoanApplication.borrower },
            },
        });

        if (profile === 'partners') {
            setNotification({
                variables: {
                    loanApplicationId: data?.loanApplication.id,
                    notification: { ...updatedLoanApplication.notification },
                },
            });
        }

        nextScreen();
        registerTagmanagerEvent(TagManagerEvent.PROFILE);
    };

    return (
        <ResponsibleInfoLayout
            initialValue={data?.loanApplication.reason ? data?.loanApplication : undefined }
            stepInfo={responsibleInfo}
            screenProfile={profile}
            onBack={previousScreen}
            onSubmit={onSubmit}
        />
    );
};

export default ResponsibleInfo;
